import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./Components/Pages//Home";
import Login from "./Components/Pages/Login";
import Dashboard from "./Components/Admin/Dashboard";
import About from "./Components/Pages/About";
import Pricing from "./Components/Pages/Pricing";
import TakeToSales from "./Components/Pages/TakeToSales";
import ContactUS from "./Components/Pages/ContactUS";
import SignUp from "./Components/Pages/SignUp";
import HowItWorks from "./Components/Pages/HowItWorks";
import CreateYourWorkspace from "./Components/Pages/CreateYourWorkspace";
import FinalizeCreateYourWorkspace from "./Components/Pages/FinalizeCreateYourWorkspace";
import PrivacyPolicy from "./Components/Pages/PrivacyPolicy";
import PrivacyPolicyApp from "./Components/Pages/PrivacyPolicyApp";
import TermConditions from "./Components/Pages/Term&Conditions";
import TermConditionsApp from "./Components/Pages/Term&ConditionsApp";
import StpSideBar from "./Components/Stp/StpSideBar";
import GrievanceRedressal from "./Components/Pages/GrievanceRedressal";
import Media from "./Components/Pages/Media";
import DownloadPage from "./Components/Pages/DownloadPage";
import BookDemo from "./Components/Stp/CashonTap/BookDemo";
import Leads from "./Components/Stp/Page/Leads";

function AllRoutes() {
  const [isAuthenticated, setAuthenticated] = useState(false);
  React.useEffect(() => {
    const tokenStatus = localStorage.getItem("token");

    if (tokenStatus === "undefined" || tokenStatus === "" || !tokenStatus) {
      setAuthenticated(false);
    } else {
      setAuthenticated(true);
    }
  }, [isAuthenticated]);

  return (
    <>
      <Router>
        <Routes>
          <Route path="/salarytap/login" element={<Login />} />
          <Route path="/salarytap/signUp" element={<SignUp />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/" element={<Home />} />

          <Route path="/salarytap/about" element={<About />} />
          <Route path="/salarytap/downloadpage" element={<DownloadPage />} />

          <Route path="/salarytap/pricing" element={<Pricing />} />
          <Route path="/salarytap/howItWorks" element={<HowItWorks />} />
          <Route path="/salarytap/talkToSales" element={<TakeToSales />} />
          <Route
            path="/salarytap/createYourWorkspace"
            element={<CreateYourWorkspace />}
          />
          <Route
            path="/salarytap/finalCreateYourWorkspace"
            element={<FinalizeCreateYourWorkspace />}
          />

          <Route path="/salarytap/media" element={<Media />} />

          <Route path="/salarytap/contact" element={<ContactUS />} />

          <Route path="/salarytap/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/salarytap/privacy-policy-app"
            element={<PrivacyPolicyApp />}
          />
          <Route
            path="/salarytap/grievance-redressal"
            element={<GrievanceRedressal />}
          />

          <Route
            path="/salarytap/term-conditions"
            element={<TermConditions />}
          />
          <Route
            path="/salarytap/term-conditions-app"
            element={<TermConditionsApp />}
          />

          <Route path="/salarytap/stp-dashboard" element={<StpSideBar />} />

          <Route path="/salarytap/dashboard" element={<Dashboard />} />
          <Route path="/salarytap/leads" element={<Leads />} />
          <Route path="/salarytap/bookdemo" element={<BookDemo />} />
        </Routes>
      </Router>
    </>
  );
}

export default AllRoutes;
